export const REGISTRATION_OPTIONS = [
  { label: 'message.common.china', value: 'CN' },
  { label: 'message.common.hk', value: 'HK' },
];

export const BUSINESS_TYPE_OPTIONS = [
  // 1: 收单  0: B2B  2: B2C
  { label: 'message.user.payout', value: '0' },
  { label: 'message.user.collection', value: '2' },
  { label: 'message.user.acquiring', value: '1' },
];
